$shm_hitalama_textbook $mol_book2
	menu_title \Учебник
	text \
	pages /
		<= Toc_page $mol_page
			title \Оглавление
			body /
				<= Toc $shm_hitalama_textbook_tree
					roots <= toc_roots /string
					children* <= toc_child_ids* /string
					expanded*? <=> toc_expanded*? true
					Item* <= Toc_link* $mol_link
						arg <= toc_arg* *
						sub / <= Toc_title* $mol_view
							sub / <= toc_title* \
		<= Text_page $mol_page
			title <= text_title \Учебник
			body /
				<= Text $shm_hitalama_textbook_text
					param <= text_param \textbook
					text <= text \
